import React from 'react';
import { getBackendUrl } from '../../../lib/api';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { FileText, Download, Brain } from 'lucide-react';

const CVAnalysisTab = ({ candidate, analysis, downloadCV }) => (
  <div className="space-y-4 md:space-y-6">
    {/* Warning if CV could not be parsed */}
    {!analysis && candidate.cv_storage_path && (
      <Card className="p-4 border-yellow-200 bg-yellow-50">
        <p className="text-sm text-yellow-800">Le CV n'a pas pu être analysé automatiquement. Vous pouvez le télécharger pour le consulter manuellement.</p>
      </Card>
    )}

    {/* CV download + text preview */}
    <Card className="p-4 md:p-6 border-tp-border">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <FileText className="h-5 w-5 text-tp-accent" />
          <h3 className="text-base md:text-lg font-display font-semibold text-tp-text">Curriculum Vitae</h3>
        </div>
        {candidate.cv_storage_path && (
          <Button variant="outline" onClick={downloadCV} className="border-tp-border" data-testid="cv-download-btn">
            <Download className="h-4 w-4 mr-2" /> Télécharger le CV
          </Button>
        )}
      </div>

      {candidate.cv_text ? (
        <div className="bg-tp-bg rounded-lg p-4 max-h-96 overflow-y-auto">
          <h3 className="text-base md:text-lg font-display font-semibold text-tp-text">Transcription du CV</h3>
          <pre className="text-sm text-tp-text-light whitespace-pre-wrap font-sans leading-relaxed mt-2">
            {candidate.cv_text}
          </pre>
        </div>
      ) : (
        <p className="text-sm text-tp-text-light">Aucune transcription disponible</p>
      )}
    </Card>

    {/* AI Analysis */}
    {analysis && (
      <Card className="p-4 md:p-6 border-tp-border">
        <div className="flex items-center gap-2 mb-4">
          <Brain className="h-5 w-5 text-tp-primary" />
          <h3 className="text-base md:text-lg font-display font-semibold text-tp-text mb-4">Analyse IA</h3>
        </div>
        
        {analysis.summary && (
          <div className="mb-4">
            <p className="text-sm font-medium text-tp-text mb-2">Résumé de l'analyse</p>
            <p className="text-sm text-tp-text-light">{analysis.summary}</p>
          </div>
        )}
        
        {analysis.ai_recommendation && (
          <div className="bg-tp-bg rounded-lg p-4">
            <p className="text-sm font-medium text-tp-text mb-2">Recommandation IA</p>
            <p className="text-sm text-tp-text-light">{analysis.ai_recommendation}</p>
          </div>
        )}
      </Card>
    )}
  </div>
);

export default CVAnalysisTab;
